var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#D80027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0436 11.8756H19.2482C19.606 11.501 19.8262 10.9938 19.8262 10.4348C19.8262 9.28228 18.8918 8.3479 17.7392 8.3479C17.0131 8.3479 16.3739 8.7189 16.0001 9.28146C15.6263 8.7189 14.987 8.3479 14.261 8.3479C13.1084 8.3479 12.174 9.28228 12.174 10.4348C12.174 10.9938 12.3942 11.501 12.752 11.8756H6.95667C6.95667 13.4124 8.29523 14.6582 9.83192 14.6582H9.73917C9.73917 16.195 10.985 17.4408 12.5219 17.4408C12.5219 17.9386 12.653 18.4052 12.882 18.8092L10.5739 21.1174L12.3448 22.8882L14.8568 20.3762C14.9552 20.4123 15.057 20.4412 15.1621 20.4609L13.6442 23.8881L16.0001 26.4348L18.356 23.888L16.8381 20.4608C16.9433 20.4411 17.045 20.4122 17.1434 20.3761L19.6554 22.888L21.4263 21.1172L19.1181 18.809C19.3472 18.4051 19.4784 17.9384 19.4784 17.4406C21.0152 17.4406 22.261 16.1949 22.261 14.658H22.1683C23.705 14.6581 25.0436 13.4124 25.0436 11.8756V11.8756Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAl);
export default __webpack_public_path__ + "static/media/AL.23a26b58.svg";
export { ForwardRef as ReactComponent };